import SetUp from "@material-symbols/svg-500/rounded/menu_book.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const SetUpIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: SetUp });
	return <Icon />;
};

export default memo(SetUpIcon);
